{
  // Initialize when DOM is ready
  document.addEventListener("DOMContentLoaded", function () {
    // Get elements
    const desktopTabs = document.querySelectorAll(".gb-tab-item");
    const mobileDropdownItems = document.querySelectorAll(".dropdown-item");
    const tabContents = document.querySelectorAll(".gb-tab-content");
    const dropdownHeader = document.getElementById("dropdownHeader");
    const dropdownMenu = document.getElementById("dropdownMenu");
    const dropdownTitle = document.querySelector(".dropdown-title");

    let activeTabIndex = 0;

    // Function to switch to a specific tab
    function switchToTab(index) {
      // Remove active class from all tabs and content
      desktopTabs.forEach((tab) => tab.classList.remove("active"));
      mobileDropdownItems.forEach((item) => item.classList.remove("active"));
      tabContents.forEach((content) => content.classList.remove("active"));

      // Add active class to current tab and content
      const targetDesktopTab = document.querySelector(
        `.gb-tab-item[data-tab-index="${index}"]`
      );
      const targetMobileTab = document.querySelector(
        `.dropdown-item[data-tab-index="${index}"]`
      );
      const targetContent = document.querySelector(
        `.gb-tab-content[data-tab-index="${index}"]`
      );

      if (targetDesktopTab) targetDesktopTab.classList.add("active");
      if (targetMobileTab) targetMobileTab.classList.add("active");
      if (targetContent) targetContent.classList.add("active");

      // Update dropdown title for mobile
      if (targetMobileTab && dropdownTitle) {
        dropdownTitle.textContent = targetMobileTab.textContent.trim();
      }

      // Update active index
      activeTabIndex = index;
    }

    // Desktop tab click handlers
    desktopTabs.forEach((tab) => {
      tab.addEventListener("click", function () {
        const tabIndex = parseInt(this.getAttribute("data-tab-index"));
        switchToTab(tabIndex);
      });

      // Add keyboard support
      tab.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.click();
        }
      });
    });

    // Mobile dropdown toggle
    if (dropdownHeader) {
      dropdownHeader.addEventListener("click", function () {
        const isOpen = dropdownMenu.classList.contains("open");

        if (isOpen) {
          dropdownMenu.classList.remove("open");
          dropdownHeader.classList.remove("open");
        } else {
          dropdownMenu.classList.add("open");
          dropdownHeader.classList.add("open");
        }
      });
    }

    // Mobile dropdown item handlers
    mobileDropdownItems.forEach((item) => {
      item.addEventListener("click", function () {
        const tabIndex = parseInt(this.getAttribute("data-tab-index"));
        switchToTab(tabIndex);

        // Close dropdown
        dropdownMenu.classList.remove("open");
        dropdownHeader.classList.remove("open");
      });

      // Add keyboard support
      item.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          this.click();
        }
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener("click", function (e) {
      if (dropdownHeader && dropdownMenu) {
        if (
          !dropdownHeader.contains(e.target) &&
          !dropdownMenu.contains(e.target)
        ) {
          dropdownMenu.classList.remove("open");
          dropdownHeader.classList.remove("open");
        }
      }
    });

    // Handle escape key to close dropdown
    document.addEventListener("keydown", function (e) {
      if (
        e.key === "Escape" &&
        dropdownMenu &&
        dropdownMenu.classList.contains("open")
      ) {
        dropdownMenu.classList.remove("open");
        dropdownHeader.classList.remove("open");
      }
    });

    // Handle window resize
    let resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        // Close mobile dropdown on resize
        if (dropdownMenu && dropdownHeader) {
          dropdownMenu.classList.remove("open");
          dropdownHeader.classList.remove("open");
        }
      }, 250);
    });

    // Initialize with first tab active
    switchToTab(0);
  });
}
